import { createAction, props } from '@ngrx/store';
import { IReportRequestDataResult } from 'src/app/models/reports';
import {
    IPerformance,
    AssetPerformanceRequest,
    IPerformanceDataResult,
    IAssetPerformanceDataResult,
    PerformanceSettings,
} from './../../../models/performance';

export const loadReportRequestData = createAction(
    '[Load Report Request Data Effect] Load Report Request Data');

export const reportRequesteDataLoaded = createAction(
    '[Report Request Data Loaded Effect] Report Request Data Loaded',
    props<{ payload: IReportRequestDataResult }>()
);

export const reportRequesteDataLoadedError = createAction(
    '[ReportRequest] Data Error',
    props<{ errorMessage: string }>()
);
